import { Modal } from "../Modal";
import { FeedbackForm } from "./FeedbackForm";
import { FeedbackPrompt } from "./FeedbackPrompt";
import { ModalFormWrapper, FormTitle } from "./Styles";
import { useSignsOfLife } from "./useSignsOfLife";
import { DueDiligenceFeedbackQuestionsConfig, DueDiligenceFeedbackStatus } from "../../Common/Hooks/useApi/Schemas";

interface FeedbackGateOverlayProps {
  feedbackStatus: DueDiligenceFeedbackStatus | null;
  feedbackConfig: DueDiligenceFeedbackQuestionsConfig | null;
  isFeedbackModalOpen: boolean;
  isSubmittingFeedback: boolean;
  initialNpsScore?: number | null;
  // The automatic first-time popup is a /report-only nudge — CaseDetails
  // relies solely on its own always-visible manual button, so it opts out.
  showAutoPrompt?: boolean;
  onCloseModal: () => void;
  onSubmit: (data: { npsScore: number; answers: Record<string, string> }) => void;
  onDismissAutoPrompt: () => void;
}

// The two feedback surfaces that float over the page regardless of layout:
// the automatic bottom banner (once, gated on the user showing signs of
// life) and the modal opened by each page's own manual trigger. A page only
// needs to mount this once and feed it the useDueDiligenceFeedbackGate state.
export const FeedbackGateOverlay = ({
  feedbackStatus,
  feedbackConfig,
  isFeedbackModalOpen,
  isSubmittingFeedback,
  initialNpsScore = null,
  showAutoPrompt = true,
  onCloseModal,
  onSubmit,
  onDismissAutoPrompt,
}: FeedbackGateOverlayProps) => {
  const canShowAutoPrompt = showAutoPrompt && Boolean(feedbackConfig && feedbackStatus?.shouldAutoPrompt);
  const signsOfLife = useSignsOfLife(canShowAutoPrompt);

  return (
    <>
      {canShowAutoPrompt && signsOfLife && feedbackConfig && (
        <FeedbackPrompt
          config={feedbackConfig}
          isSubmitting={isSubmittingFeedback}
          onSubmit={onSubmit}
          onDismiss={onDismissAutoPrompt}
        />
      )}

      {feedbackConfig && (
        <Modal isOpen={isFeedbackModalOpen} onClose={onCloseModal} fullScreen={false}>
          <ModalFormWrapper>
            <FormTitle>Danos tu opinión sobre este informe</FormTitle>
            <FeedbackForm
              config={feedbackConfig}
              isSubmitting={isSubmittingFeedback}
              onSubmit={onSubmit}
              onClose={onCloseModal}
              initialNpsScore={initialNpsScore}
            />
          </ModalFormWrapper>
        </Modal>
      )}
    </>
  );
};
